import {
  ROOT,
  HOTEL_CHAIN_GET_DETAIL,
  HOTEL_CHAIN_ADD_HOTEL,
  HOTEL_CHAIN_REMOVE_HOTEL,
  HOTEL_CHAIN_SAVE
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function getHotelChainDetail() {
  return fetch(ROOT + HOTEL_CHAIN_GET_DETAIL, requestOptions.get())
    .then(handleResponse);
}

function addHotel(data) {
  return fetch(ROOT + HOTEL_CHAIN_ADD_HOTEL, requestOptions.post(data))
    .then(handleResponse);
}

function removeHotel(id) {
  return fetch(ROOT + HOTEL_CHAIN_REMOVE_HOTEL + `/` + id, requestOptions.get())
    .then(handleResponse);
}

function saveHotelChain(data) {
  return fetch(ROOT + HOTEL_CHAIN_SAVE, requestOptions.post(data))
    .then(handleResponse);
}

export const service = {
  getHotelChainDetail,
  addHotel,
  removeHotel,
  saveHotelChain
};